'use strict';

/**
 *
 * @name: generalStorySlider
 *
 */

import DirectiveTemplate from './general-story-slider.directive.html';

function GeneralStorySlider(
  $compile,
  $location,
  $q,
  $rootScope,
  $stateParams,
  apiPostService,
  apiPicksService,
  transObject,
  $state
) {

  'ngInject';

  return {
    template: DirectiveTemplate,
    link: function link(scope, element, attrs) {

      scope.common = {

        justAddingNewPosts: false
      };

      scope.changeHtml = function() {

        scope.settings.change = true;
      };

      if (attrs.introText) {

        scope.introText = attrs.introText;
      }

      scope.postChosen = true;

      scope.loadMore = function() {

        apiPicksService
          .getPicks('isBefore', scope.list[scope.list.length - 1].translations[$rootScope.lang].slug)
          .then(function(res) {

            scope.list.push.apply(scope.list, res.data.items);
          });
      };

      scope.loadMoreLeft = function() {

        var deferred = $q.defer();

        apiPicksService
          .getPicks('isAfter', scope.list[0].translations[$rootScope.lang].slug)
          .then(function(res) {

            scope.list.unshift.apply(scope.list, res.data.items);
            scope.settings.index = scope.settings.index + res.data.items.length;
            deferred.resolve(res.data.items.length);
          });
        return deferred.promise;
      };

      scope.playIndex = function(index) {

        // This is bacause we need to identify the situation when user choses the post for the first time.
        // In this situation postSlug is still empty.
        scope.settings.change = true;

        if (index !== scope.settings.index && $stateParams.slug || !$stateParams.slug) {

          var data = {
            dontGoNext: true,
          };
          scope.settings.index = index;
          scope.postChosen = true;
          _changePlayedPost(index);
          $rootScope.$broadcast('filmFinished', data);
        }
      };

      function _changeLocationPath() {

        if ($state.params.slug === scope.post.translations[$rootScope.lang].slug) {

          return;
        }

        $rootScope.forceRouterToNotSync = true;
        $location.path('/picks/' + scope.post.translations[$rootScope.lang].slug);
      }

      function _changePlayedPost(newVal) {

        if (scope.common.justAddingNewPosts) {

          scope.common.justAddingNewPosts = false;
          return;
        }

        if (newVal || newVal === 0) {

          var extWrap = element.find('.ext-wrap');
          extWrap.stop().animate({
            scrollLeft: 240 * (scope.settings.index - 1)
          }, 300, 'swing');

          if (scope.settings.index !== 0) {

            element.find('.prev').removeClass('hidden');
          } else {

            element.find('.prev').addClass('hidden');
          }

          if (scope.settings.index !== scope.list.length - 1) {

            element.find('.next').removeClass('hidden');
          } else {

            element.find('.next').addClass('hidden');
          }

          if ($stateParams.slug || $location.search().autoplay || scope.postChosen) {
            console.log(scope.list,newVal)
            if (scope.list[newVal].statusCn !== 'published' || !scope.list[newVal].isPublished) {

              if (newVal < scope.list.length - 1) {

                scope.playIndex(newVal + 1);
              } else {

                scope.playIndex(0);
              }
            }

            apiPostService
              .getPostBySlug(scope.list[scope.settings.index].translations[$rootScope.lang].slug)
              .then(function(res) {

                _decoratePost(res.data);
                scope.post = res.data;
                scope.settings.post = res.data;

                _compilePostDescription();
                scope.postReady = true;

                _changeLocationPath();
                $rootScope.$broadcast('postChange', scope.post);
              });

          }
        }
      }

      function _compilePostDescription() {

        var compileContainer = element.find('.series-post-compile-container');
        compileContainer.empty();
        compileContainer.html('<p data-compile data-ng-if="postReady"></p>');
        $compile(compileContainer.contents())(scope);
      }

      function _decoratePost(post) {

        transObject.translate(post);
        transObject.setBookmark(post);
        transObject.calendarDate(post);
        transObject.translate(post.category);

        if (post.tags && post.tags.length) {
          post.tags.forEach(function(tag) {
            transObject.translate(tag);
          });
        }

        transObject.myAss(post);

        if (post.contributors && post.contributors.length) {

          post.contributors.forEach(function(contributor) {

            transObject.trueSlug(contributor);
          });
        }
      }

      scope.$watch('settings.index', _changePlayedPost);
    },
  };
}

export default GeneralStorySlider;



// WEBPACK FOOTER //
// ./app/pages/story/general-story-slider.directive.js